// extracted by mini-css-extract-plugin
export default {"joblist":"JobList_joblist__TRMb4","joblist-item":"JobList_joblist-item__wlTdp","job-highlight":"JobList_job-highlight__zZo7p","border":"JobList_border__Hq5Xt"};